import Vue from 'vue'
import {shopLayout} from './ShopLayout';
import Component from 'vue-class-component'
import {Inject} from 'vue-property-decorator';
import {BasketProductSubmission} from '@/global/BasketProductSubmission';
import {AddedBasketItem} from '@/global/AddedBasketItem';
import {ConfigurationChoices} from '@/global/ProductConfigurationPrefill';
import {
    BasketApi,
    BasketDto,
    ConfiguredImageDto,
    ConfiguredProductDto,
    CouponApi,
    CouponDto,
    CustomerApi,
    ImageDto, ImageRequirementDto,
    PaymentMethodDto,
    PersonDto,
    ProductApi,
    ProductDto,
    ProductCategoryApi,
    ProductCategoryDto
} from "@swagger";
import router from "@/router";
import {loadStripe} from '@stripe/stripe-js/pure';
//import router from "@/router";

declare var grecaptcha: any;

@Component
export default class BasicComponent extends Vue {

    shopLayout = shopLayout;

    get mobile(): boolean {
        return this.$vuetify.breakpoint.smAndDown;
    }

    get hasCoupons(): boolean {
        return (this.$store.getters.coupons?.length ?? 0) > 0;
    }


    @Inject({from: 'basketProductSubmission', default: null}) basketProductSubmission: BasketProductSubmission | null;

    async addConfiguredProducts(products: ConfiguredProductDto[], success: (items: AddedBasketItem[]) => void,
                                error: (message: string) => void, choices: ConfigurationChoices[] = []): Promise<void> {
        if (this.basketProductSubmission?.submit) {
            await this.basketProductSubmission.submit(products, success, error, choices);
            return;
        }
        const items = new Map<number, AddedBasketItem>();
        let firstError: string | null = null;
        for (const [index, product] of products.entries()) {
            await this.addArticleToBasket(product.productId, product.images, product.detailedConfiguration,
                item => {
                    if (!item) return;
                    const previous = items.get(item.position.id);
                    items.set(item.position.id, {...item, choices: choices[index],
                        amount: item.amount + (previous?.amount ?? 0)});
                }, message => { if (!firstError) firstError = String(message); });
        }
        if (items.size) success(Array.from(items.values()));
        if (firstError) error(firstError);
    }

    /*
    requestCaptchaToken() {
        const onCaptchaVerification = this.onCaptchaVerification;
        const _this = this;
        grecaptcha.ready(function () {
            grecaptcha.execute(_this.$t("captchaClientKey").toString(), {action: 'homepage'}).then(function (token) {
                onCaptchaVerification(token);
            });
        });
    };
     */

    get hasImages() {
        return this.$store.getters.imageSelection.images.length > 0;
    }

    get committedCodes(): string[] {
        return (this.$store.getters.imageSelection.persons ?? []).map(person => person.code);
    }

    get codesInputMatchesSelection() {
        const committedCodes: string[] = this.committedCodes
        const codesInput: string[] = this.$store.getters.codesInput;
        return codesInput.every(code => committedCodes.includes(code))
            && committedCodes.every(code => codesInput.includes(code))
    }

    get apiConfiguration() {
        return {
            basePath: getApiUrl(),
        };
    }

    removeCodesFromQueryParams() {
        const query = { ...this.$route.query }
        if (query.codes) {
            delete query.codes
            this.$router.replace({query})
        }
    }

    get globalRules() {
        return {
            present: value => {
                return (value && value.length > 0) || this.$t("CHECKOUT_FIELD_REQUIRED")
            },
            email: value => {
                if (value) {
                  value = value.trim();
                }
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || this.$t("CHECKOUT_ADDITIONAL_INVALID_EMAIL")
            },
            max500: value => {
                return !(value && value.length > 500) || this.$t("CHECKOUT_ADDITIONAL_CHAR_LIMIT");
            },
            checked: value => {
                return value === true || this.$t("TERMS_CONDITIONS_REQUIRED");
            }
        };
    }

    async setStep(step, alwaysEmitEvent=false, saveInQuery=true) {
        step = Number(step);
        console.log("Set step", step);
        const stepBefore = Number(this.$store.getters.step);
        this.$store.commit("setStep", step);
        console.log(this.$route.fullPath);
        if (saveInQuery) {
          const router = this.$router;
          const query = Object.assign({}, router.currentRoute.query);
          query.step = String(step);
          if (router.currentRoute.name === "home" && router.currentRoute.query.step != step) {
            await router.push({query: query}).catch(err => {
              console.error(err);
            });
          }
        }
        if (stepBefore !== step || alwaysEmitEvent) {
            const pages = {
                1: "Code-Eingabe",
                2: "Bild-Präsentation",
                3: "Produkte"
            };
            this.trackPage(pages[Number(step)]);
        }
    }

    async goToStep(step) {
      await this.setStep(step, true);
      if (this.$route.name !== "home") {
        await this.$router.push({path: "/", query: {step: step?.toString()}});
      }
    }

    trackPage(page: string) {
        try {
            window["_paq"].push(["trackPageView", page]);
            /*
            this["$ga"].page({
                page: page,
                title: page,
                location: window.location.href
            });
             */
        } catch (e) {
            console.error(e);
        }
    }

    trackEvent(category, action, label=undefined, value=undefined) {
        window["_paq"].push(["trackEvent", category, action, label, value]);
        /*
        this["$ga"].event({
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
        });
         */
    }

    onCaptchaVerification(token) {
        this.$store.commit("setCaptchaToken", token);
    }

    checkIfNewsletterAccepted(then) {
        new CustomerApi(this.apiConfiguration).isCustomerRegistered()
            .then((accepted: boolean) => {
                this.$store.commit("setNewsletterAccepted", accepted);
                if (then) {
                  then(accepted);
                }
            }).catch((err) => {
                console.error(err)
        });
    }

    get newsletterAccepted() {
        return this.$store.getters.newsletterAccepted;
    }

    requestProducts() {
        new ProductApi(this.apiConfiguration).getProducts()
            .then((data: Array<ProductDto>) => {
                this.$store.commit("setProducts", data)
            })
            .catch((err) => {
                console.error(err);
            });
    }

    requestCoupons() {
        new CouponApi(this.apiConfiguration).getCoupons()
            .then((data: Array<CouponDto>) => {
                this.$store.commit("setCoupons", data)
            })
            .catch((err) => {
                console.error(err);
            });
    }

    requestProductCategories() {
        new ProductCategoryApi(this.apiConfiguration).getProductCategories()
            .then((data: Array<ProductCategoryDto>) => {
                this.$store.commit("setProductCategories", data)
            })
            .catch((err) => {
                console.error(err);
            });
    }


    getBasketData() {
        new BasketApi(this.apiConfiguration).getBasket()
            .then((data: BasketDto) => {
                this.$store.commit("setBasket", data);
            })
            .catch((err) => {
                err.json().then(error => {
                    console.error(error.message)
                });
            });
    }

    addingUnconfiguredProduct = false;

    async addUnconfiguredProduct(product: ProductDto, then, error): Promise<void> {
        if (this.addingUnconfiguredProduct) return;
        this.addingUnconfiguredProduct = true;
        try {
            await this.addArticleToBasket(product.id, [], false, then, error);
        } finally {
            this.addingUnconfiguredProduct = false;
        }
    }

    addArticleToBasket(productId: number, images: Array<ConfiguredImageDto>, detailedConfiguration: boolean, then, error) {
        const previous: BasketDto = this.$store.getters.basket;
        const amounts = new Map((previous?.positions ?? []).map(position => [position.id, position.amount]));
        const configuration = {
            productId: productId,
            images: images,
            detailedConfiguration: detailedConfiguration
        };
        return new BasketApi(this.apiConfiguration).addProduct(configuration)
            .then((data: BasketDto) => {
                this.$store.commit("setBasket", data);
                const positions = (data.positions ?? []).filter(position => position.product.productId === productId);
                const position = positions.find(position => position.amount > (amounts.get(position.id) ?? 0))
                    // Purely digital products stay at one even when added again.
                    ?? positions.find(position => position.product.images.length === images.length
                        && position.product.images.every(image => images.some(selected => selected.imageId === image.imageId
                            && (selected.imageCropId ?? null) === (image.imageCropId ?? null)
                            && (this.$store.getters.product(productId).imageFilter ?? selected.filter ?? 'NONE') === image.filter)));
                const amount = position ? Math.max(0, position.amount - (amounts.get(position.id) ?? 0)) : 0;
                then(position && amount > 0 ? {position, amount, configuration} : null);
                if (amount > 0) this.trackEvent("Warenkorb", "Hinzugefügt", undefined, this.$store.getters.product(productId).price);
            })
            .catch(async (err) => {
                const detail = typeof err.json === 'function' ? await err.json().catch(() => null) : null;
                error(detail?.message ?? String(err.message ?? err));
            });
    }

    editBasketPositionAmount(positionId, amount, then, error) {
        new BasketApi(this.apiConfiguration).editPositionAmount({
            positionId: positionId,
            amount: amount
        })
            .then((data: BasketDto) => {
                this.$store.commit("setBasket", data);
                then()
            })
            .catch((err) => {
                err.json().then(e => {
                    error(e.message)
                });
            });
    }

    deleteBasketPosition(positionId, then, error) {
        new BasketApi(this.apiConfiguration).deletePosition({
            positionId: positionId
        })
            .then((data: BasketDto) => {
                this.$store.commit("setBasket", data);
                then()
            })
            .catch((err) => {
                err.json().then(e => {
                    error(e.message)
                });
            });
    }

    convertPriceForStripe(price: number): number {
        return Math.round(price * 100);
    }

    formatPrice(price: Number) {
        if (!price) {
          price = 0.0;
        }
        const formatted = price.toFixed(2).replace(".", ",");
        return this.applyPriceFormat(formatted);
    }

    formatPriceShort(price: Number) {
        if (!price) {
          return this.applyPriceFormat("0");
        }
        const formatted = price % 1 === 0
            ? Math.trunc(+price).toString()
            : (+price).toFixed(2).replace(/0+$/, "").replace(".", ",");
        return this.applyPriceFormat(formatted);
    }

    private applyPriceFormat(formattedNumber: string): string {
        const template = this.$t?.("PRICE_FORMAT")?.toString() ?? "{price} €";
        return template.replace("{price}", formattedNumber);
    }

    formatDate(date: string): string {
        const split = date.split("-");
        return split[2] + "." + split[1] + "." + split[0];
    }

    getImageUrl(url, filter = "NONE") {
        if (!filter) {
          filter = "NONE";
        }
        if (url.includes("?")) {
          return `${url}&filter=${filter}`;
        }
        return `${url}&filter=${filter}`;
    }

    get isMobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                check = true;
            }
        })(navigator.userAgent || navigator.vendor || window["opera"]);
        return check;
    }

    set isMobile(val) {}

    replaceLast(str: string, replace: string, replacement: string): string {
        if (! str.includes(replace)) {
          return str;
        }
        var pcs = str.split(replace);
        var lastPc = pcs.pop();
        return pcs.join(replace) + replacement + lastPc;
    };

    flattenArray(arr: Array<Array<any>>): Array<any> {
        return arr.reduce((acc, val) => acc.concat(val), []);
    }

    paymentMethodActive(method) {
        return this.$t("PAYMENTMETHOD_ACTIVE_" + method) === "true";
    }

    private static readonly STRIPE_PAYMENT_METHODS = [
        "CREDIT_CARD", "SOFORT", "EPS", "KLARNA_NOW", "KLARNA_LATER", "APPLE_PAY", "GOOGLE_PAY", "PAYPAL"
    ];

    static readonly MANUAL_PAYMENT_METHODS = [PaymentMethodDto.BANKTRANSFER, PaymentMethodDto.CASHENVELOPE] as const;

    get isStripeRequired(): boolean {
        return BasicComponent.STRIPE_PAYMENT_METHODS.some(m => this.paymentMethodActive(m));
    }

    get allPersons(): PersonDto[] {
        return this.$store.getters.persons;
    }

    getPersonImages(person: PersonDto): ImageDto[] {
        if (! person) {
            return [];
        }
        return person.imageIds.map(uniqueId => this.$store.getters.imageById(uniqueId));
    }

    imageMatchesRequirement(image: ImageDto, requirement: ImageRequirementDto): boolean {
        return requirement.types.includes(image.type) && requirement.orientations.includes(image.orientation);
    }

    loadStripe() {
        if (!this.isStripeRequired) {
          return;
        }
        if (this.$store.getters.stripe) {
          return;
        }
        loadStripe(this.$t("stripePublicKey").toString())
          .then((stripe) => {
              this.$store.commit("setStripe", stripe);
          })
          .catch((err) => {
              console.error("Error while loading stripe", err);
          });
    }

    get stepSet(): boolean {
      return this.$route.query.step != undefined;
    }

    /**
     * Can also be used during initialization of the component, before the $t function is available.
     */
    t(key: string, params?: any): string {
        if (! this.$t) {
          return key;
        }
        return this.$t(key, params).toString();
    }

};

export function getApiUrl() {
    return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port;
}
